<template>
  <div class="share-list-item">
    <span class="Popover-arrow"></span>
    <a :href="url" target="_blank">
    <div class="item-share"><svg  class="Zi Zi--InsertLink" 
      fill="#9fadc7"
      viewBox="0 0 42.43 38.36" 
      width="14"><title>资源 1</title><g id="图层_2" 
      data-name="图层 2"><g id="图层_1-2" data-name="图层 1"><path class="cls-1" d="M9.94,3H3L3,29.7a1.48,1.48,0,0,1-3,0L0,3A3,3,0,0,1,3,0h8.2l4.49,4.43h23a1.48,1.48,0,1,1,0,3H14.43L9.95,3Zm0,0"></path><path class="cls-1" d="M3.11,29.49A1.48,1.48,0,0,1,.2,29L2.72,14.5a5.14,5.14,0,0,1,4.92-4.17H38.47A3.89,3.89,0,0,1,42.36,15L39,34.18a5.14,5.14,0,0,1-4.92,4.17H4.6a1.48,1.48,0,0,1,0-3H34.11a2.19,2.19,0,0,0,2-1.73L39.45,14.5a1,1,0,0,0-1-1.22H7.63a2.19,2.19,0,0,0-2,1.73Zm0,0"></path></g></g></svg>{{$t('share.openLink')}}</div></a>
      <div class="item-share" @click="setPrivate">
        <!--<svg class="Zi Zi&#45;&#45;InsertLink" fill="#9fadc7" viewBox="0 0 24 24" width="20" height="20"><path d="M6.77 17.23c-.905-.904-.94-2.333-.08-3.193l3.059-3.06-1.192-1.19-3.059 3.058c-1.489 1.489-1.427 3.954.138 5.519s4.03 1.627 5.519.138l3.059-3.059-1.192-1.192-3.059 3.06c-.86.86-2.289.824-3.193-.08zm3.016-8.673l1.192 1.192 3.059-3.06c.86-.86 2.289-.824 3.193.08.905.905.94 2.334.08 3.194l-3.059 3.06 1.192 1.19 3.059-3.058c1.489-1.489 1.427-3.954-.138-5.519s-4.03-1.627-5.519-.138L9.786 8.557zm-1.023 6.68c.33.33.863.343 1.177.029l5.34-5.34c.314-.314.3-.846-.03-1.176-.33-.33-.862-.344-1.176-.03l-5.34 5.34c-.314.314-.3.846.03 1.177z" fill-rule="evenodd"></path></svg>-->
        <svg  class="Zi Zi-privent" fill="#9fadc7" viewBox="0 0 44.09 44.09" width="15"><title>资源 2</title><g id="图层_2" data-name="图层 2"><g id="图层_1-2" data-name="图层 1"><path class="cls-1" d="M30.31,16.53V11a8.27,8.27,0,1,0-16.53,0v5.51H11V11a11,11,0,1,1,22,0v5.51Zm2.76,0H30.31V11a8.27,8.27,0,1,0-16.53,0v5.51H11V11a11,11,0,1,1,22,0ZM5.51,19.29A2.76,2.76,0,0,0,2.76,22V38.58a2.76,2.76,0,0,0,2.76,2.76H38.58a2.76,2.76,0,0,0,2.76-2.76V22a2.76,2.76,0,0,0-2.76-2.76Zm0-2.76H38.58A5.51,5.51,0,0,1,44.09,22V38.58a5.51,5.51,0,0,1-5.51,5.51H5.51A5.51,5.51,0,0,1,0,38.58V22a5.51,5.51,0,0,1,5.51-5.51Zm0,0"></path><path class="cls-1" d="M22,31.69a4.13,4.13,0,1,1,4.13-4.13A4.13,4.13,0,0,1,22,31.69Zm0-2.07A2.07,2.07,0,1,0,20,27.56,2.07,2.07,0,0,0,22,29.62Zm0,0"></path><path class="cls-1" d="M20.67,30.31h2.76v5.51A1.38,1.38,0,0,1,22,37.2h0a1.38,1.38,0,0,1-1.38-1.38Z" ></path></g></g></svg>
        {{$t('share.keptPrivate')}}</div>
    <!--<a :href="shareWeibo" target="_blank">-->
    <div class="item-share" @click="shareWeibo">
      <svg viewBox="0 0 22 18" class="Icon Icon--weibo Icon--left" width="16" height="16" aria-hidden="true"><title></title><g><g fill-rule="evenodd">     <path d="M14.518.06s-.87.644.03 1.71c0 0 6.287-1.19 5.69 6.33 0 0 1.05 1.13 1.674-.31 0 .002 1.44-8.584-7.394-7.73zM4.883 13.17s.038 2.584 3.326 2.584c3.657 0 3.683-2.98 3.683-2.98S12.1 9.67 8.687 9.61c-3.863-.07-3.804 3.56-3.804 3.56zM7.41 14.21c-.668 0-1.214-.447-1.214-.998 0-.55.543-.998 1.215-.998.67 0 1.213.447 1.213.998 0 .55-.54.998-1.212.998z"></path><path d="M4.317 4.52C-2.603 10.353.873 14.85.873 14.85c.57 1.01 3.382 3.1 8.596 3.1 5.21 0 9.314-3.628 9.314-6.44 0-2.813-2.918-2.714-2.918-2.714 1.04-1.554.19-2.65.19-2.65-1.684-2.118-5.404-.16-5.407-.158.772-1.717.11-2.797.11-2.797C8.932.66 4.317 4.52 4.317 4.52zm10.448 7.79s-.467 4.16-6.447 4.16c-5.745 0-5.82-3.322-5.842-3.712 0 0-.073-4.423 6.58-4.654 5.94-.204 5.71 4.207 5.71 4.207zM18.65 7.045s1.018-4.37-3.864-3.818c0 0-.628.58.09 1.346 0 0 2.602-.58 2.397 2.598 0 0 .715.885 1.376-.125z"></path></g></g></svg>{{$t('share.sina')}}</div>
    <!--</a>-->
    <div class="item-share wx-share">
      <svg viewBox="0 0 20 19" class="Icon Icon--wechat Icon--left" width="14" height="14" aria-hidden="true"><title></title><g><path fill-rule="evenodd" d="M.224 18.667s4.24-1.825 4.788-2.056C13.03 20.14 20 14.715 20 8.9 20 3.984 15.523 0 10 0S0 3.984 0 8.898c0 1.86.64 3.585 1.737 5.013-.274.834-1.513 4.757-1.513 4.757zM6.167 8.96c.69 0 1.25-.57 1.25-1.27 0-.703-.56-1.272-1.25-1.272s-1.25.57-1.25 1.27c0 .703.56 1.272 1.25 1.272zm7.583 0c.69 0 1.25-.57 1.25-1.27 0-.703-.56-1.272-1.25-1.272s-1.25.57-1.25 1.27c0 .703.56 1.272 1.25 1.272z"></path></g></svg>{{$t('share.weixin')}}
      <div class="erweima">
        <qrcode-vue
          :value="value"
          :size="size"
          level="H"></qrcode-vue>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .Icon--wechat{
    fill: rgb(125, 210, 57);
    height: 14px;
    width: 14px;
    margin-left: 5px;
    margin-right: 5px;
  }
  .Icon--weibo{
    fill: rgb(249, 110, 118);
    height: 16px;
    width: 16px;
    margin-right: 6px;
    margin-left: 5px;
    vertical-align: middle;
  }
  .share-list-item{
    position: relative;
    width: 110px;
    /*height: 100px;*/
    padding: 6px 0;
    color: #8590a6;
    background: #ffffff;
    border: 1px solid #ebebeb;
    border-radius: 4px;
    -webkit-box-shadow: 0 5px 20px rgba(26,26,26,.1);
    box-shadow: 0 5px 20px rgba(26,26,26,.1);
    z-index: 203;
    text-align: center;
  }
  .item-share.wx-share:hover{
    background: inherit;
    color: inherit;
  }
  .item-share.wx-share{
    height:auto;
  }
  .item-share.wx-share .erweima{
    width: 94px;
    height: 94px;
    margin: 0 auto;
    background: #ccc;
  }
  .item-share{
    height: 35px;
    font-size: 14px;
    display: block;
    width: 100%;
    padding: 0 6px;
    text-align: left;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 35px;
  }
  a{
    color: #8590a6;
  }
  .item-share:hover{
    background: rgba(146, 137, 137, 0.1);
    color: #666;
  }
  .Zi--InsertLink{
    vertical-align: middle;
    margin-right: 8px;
    margin-left: 6px;
    line-height: 40px;
    vertical-align: middle;
  }
  .Zi-privent{
    vertical-align: middle;
    margin-right: 2px;
    margin-left: 6px;
    line-height: 40px;
    vertical-align: middle;
  }

  .Popover-arrow, .Popover-arrow:after {
    border: 8px solid transparent;
    display: block;
    width: 0;
    height: 0;
    border-top-width: 0;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    position: absolute;
  }
  .Popover-arrow:after {
    margin-top: 1px;
    border-bottom-color: #fff;
    left: 0;
    top: 0;
    content: "";
  }
  .Popover-arrow{
    left: 50%;
    bottom: -8px;
    z-index: 99;
    border-bottom-color: #ebebeb;
    margin-top: -8px;
    transform: rotate(180deg);
  }
</style>
<script>

  import QrcodeVue from 'qrcode.vue';
  import {getArticlePublic} from'@/api/user'

//  let locationUrl = window.location.origin;
//  locationUrl = window.location.hostname =='localhost'? 'http://www.caiyunapp.com':window.location.origin
  export default {
    name: "ShareList",
    components: {
      QrcodeVue
    },
    data() {
      return {
          value: 'https://www.caiyunapp.com/article/?id='+this.id,
          size: 94
      };
    },
    mounted (){
    },
    props:{
      url:'',
      id:'',
      imgUrl:'',
      des:'',
      title:'',
      public_url:''
    },
    created(){

    },
    methods: {
      setPrivate(){
        getArticlePublic({
          article_id: this.id,
          value:false
        }).then(res=>{
            if(res.rc == 0){
                if(res.article.public == false ){
                  this.$emit('refreshList',res.article);
                }
            }
        })
      },
      shareWeibo(){
        const linkUrl = 'http://v.t.sina.com.cn/share/share.php?url=https://'
          + window.location.host + '/article/?id='+this.id +'&title=' + this.title + '。  ' + this.des + '&content=utf8&pic=' + this.imgUrl || 'https://www.caiyunapp.com/images/favorite-null.png';
        console.log(linkUrl);
        window.open(linkUrl)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ShareList.vue